import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from '../SnackBar';

export const CLUBS_PATCH_REQUEST = 'PATCH_CLUBS_REQUEST';
export const CLUBS_PATCH_FAILURE = 'PATCH_CLUBS_FAILURE';
export const CLUBS_PATCH_SUCCESS = 'PATCH_CLUBS_SUCCESS';

export const patchClub = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.CLUBS.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data));
                dispatch(addSuccessMessage('Association successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => ({type: CLUBS_PATCH_REQUEST});
const postFailure = error => ({type: CLUBS_PATCH_FAILURE, error});
const patchSuccess = club => ({type: CLUBS_PATCH_SUCCESS, club});